var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs6":""}},[_c('v-flex',{staticClass:"meeting-tools__links",attrs:{"md6":""}},[_c('i',{staticClass:"fas fa-handshake"}),_c('v-flex',{attrs:{"tag":"strong"}},[_vm._v(_vm._s(_vm.toolKitConstants.QUICK_MEETING))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }